// @core/api/endpoints/platform/list_federation_peers.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListFederationPeersResponse,
} from '../../../types/platform';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/platform';

/**
 * List federation peers
 * Returns all federation peer connections for the platform, including pending, active, and revoked peers.
 */
export async function ListFederationPeers(
  platform_id: string,
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListFederationPeersResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/platforms/:platform_id/federation/peers`;
  requestPath = requestPath.replace(':platform_id', encodeURIComponent(platform_id));
  const requestOptions = options;
  return client.get<ListFederationPeersResponse>(requestPath, { ...requestOptions, params });
}
